import { fetchApi } from "./api";
import { API_ENDPOINTS } from "@/config/api";

export type SourceTier = "premium" | "sponsored";

export const TIER_LIMITS: Record<SourceTier, number> = {
  premium: 5,
  sponsored: 20,
};

export interface FeaturedSource {
  id: number;
  source_id: string;
  tier: SourceTier;
  context: string;
  start_date: string | null;
  end_date: string | null;
  created_at: string;
  updated_at: string;
}

export interface FeaturedSourceCreate {
  source_id: string;
  tier: SourceTier;
  context?: string;
  start_date?: string | null;
  end_date?: string | null;
}

export interface FeaturedSourceUpdate {
  tier?: SourceTier;
  context?: string;
  start_date?: string | null;
  end_date?: string | null;
}

export async function listFeaturedSources(): Promise<FeaturedSource[]> {
  return fetchApi<FeaturedSource[]>(API_ENDPOINTS.featuredSources);
}

export async function createFeaturedSource(
  data: FeaturedSourceCreate,
): Promise<FeaturedSource> {
  return fetchApi<FeaturedSource>(API_ENDPOINTS.featuredSources, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateFeaturedSource(
  id: number,
  patch: FeaturedSourceUpdate,
): Promise<FeaturedSource> {
  return fetchApi<FeaturedSource>(API_ENDPOINTS.featuredSourceById(id), {
    method: "PUT",
    body: JSON.stringify(patch),
  });
}

export async function deleteFeaturedSource(id: number): Promise<void> {
  return fetchApi<void>(API_ENDPOINTS.featuredSourceById(id), {
    method: "DELETE",
  });
}
